
export const PESQUISA_ID = {
  NOVA_FICHA_DE_OBRAS: 2,
  CSAT_BUSCA_POR_EMPRESAS: 3,
} as const;

export interface PerguntasAcompanhamentoCsat {
  /** Notas 1 e 2 */
  baixa: string;
  /** Nota 3 */
  media: string;
  /** Notas 4 e 5 */
  alta: string;
}

export interface ConfiguracaoCsat {
  perguntasAcompanhamento: PerguntasAcompanhamentoCsat;
  motivos: string[];
}

export const CSAT_PADRAO: ConfiguracaoCsat = {
  perguntasAcompanhamento: {
    baixa: 'O que não funcionou bem?',
    media: 'O que faltou para ser melhor?',
    alta: 'O que mais te ajudou?',
  },
  motivos: [],
};

export const CSAT_BUSCA_POR_EMPRESAS: ConfiguracaoCsat = {
  perguntasAcompanhamento: {
    baixa: 'O que dificultou sua busca?',
    media: 'O que faltou para ser melhor?',
    alta: 'O que mais te ajudou?',
  },
  motivos: [
    'Não encontrei a empresa',
    'Resultados confusos',
    'Faltam filtros',
    'Página lenta',
  ],
};